import m from 'mithril'
import { events, states } from '../components/state'
import { AddToCartButton, CartIcon, Cart } from '../components/cart'
import { PrescriptionSelector, PrescriptionToggleButton } from '../components/prescription-selector'

const { hostname, pathname } = window.location
const path = pathname

switch(true) {
  // Cart page
  case /^\/cart$/.test(path):
    // Someday...
    break

  // Collection page
  case /^\/collections\/[^\/]+$/.test(path):
    // mountBlockAddToCartButton()
    break

  // Product page
  case /\/products\/[^\/]+$/.test(path):
    // mountAddToCartButton()
    // mountQuickAddToCartButton()
    break

  case /^\/\pages\/[^\/]+$/.test(path):
    if(Shopify.Product) {
      mountPageProductToCartButton()
    }
    mapProductWithButton()
    break
  
  default:
    break
}

m.mount(document.getElementById('cart-drawer'), {
  view: () => m(Cart, { events, state: states(), format: Shopify.currencyFormat, context: {
    basket: Shopify.Basket
  }})
})

m.mount(document.getElementById('header_icon-cart'), {
  view: () => m(CartIcon, { events, state: states() })
})

function mountAddToCartButton() {
  let productAddToCartButton = document.querySelector('.product_buttonContainer')
  const productType = Shopify.Product.type
  const isAvailPreorder = Shopify.Product.preorderAvail

  if (productType.indexOf('Prescription') > -1) {
    let prescriptionSelector = document.getElementById('PrescriptionSelector')
    if (prescriptionSelector) {
      m.mount(prescriptionSelector, {
        view: () => m(PrescriptionSelector, {
          events,
          context: {
            addToCartText: Shopify.Button.PrescriptionButtonText,
            Prescription: Shopify.Prescription
          },
          state: states(),
          moneyFormat: Shopify.currencyFormat,
          product: Shopify.Product,
          productOptions: Shopify.ProductOptions
        })
      })
      m.mount(productAddToCartButton, {
        view: () => m(PrescriptionToggleButton, {
          events,
          context: {
            addToCartText: Shopify.Button.PrescriptionButtonText,
            soldOutText: Shopify.Button.SoldOutText, 
            preorderText: Shopify.Button.PreorderText
          },
          state: states(),
          colour: 'green',
          moneyFormat: Shopify.currencyFormat,
          activeProductAvail: Shopify.Product.available,
          activeProductPreAvail: isAvailPreorder,
          activeProductId: Shopify.Product.id,
          activeProductPrice: Shopify.Product.price,
          activeProductSalePrice: Shopify.Product.compare_at_price
        })
      })

    }
  } else {
    if (productAddToCartButton) {
      m.mount(productAddToCartButton, {
        view: () => m(AddToCartButton, {
          events,
          context: {
            addToCartText: Shopify.Button.AddToCartText,
            soldOutText: Shopify.Button.SoldOutText, 
            preorderText: Shopify.Button.PreorderText
          },
          state: states(),
          colour: 'green',
          moneyFormat: Shopify.currencyFormat,
          activeProductAvail: Shopify.Product.available,
          activeProductPreAvail: isAvailPreorder,
          activeProductId: Shopify.Product.id,
          activeProductPrice: Shopify.Product.price,
          activeProductSalePrice: Shopify.Product.compare_at_price
        })
      })
    }
  }
}

// Quick add bar
function mountQuickAddToCartButton() {
  const productType = Shopify.Product.type
  const isAvailPreorder = Shopify.Product.preorderAvail
  const productAddToCartButton = document.getElementById('quickAddButton')

  if (productType.indexOf('Prescription') > -1) {
    let prescriptionSelector = document.getElementById('PrescriptionSelector')
    if (prescriptionSelector) {
      m.mount(prescriptionSelector, {
        view: () => m(PrescriptionSelector, {
          events,
          context: {
            addToCartText: Shopify.Button.PrescriptionButtonText,
            Prescription: Shopify.Prescription
          },
          state: states(),
          moneyFormat: Shopify.currencyFormat,
          product: Shopify.Product,
          productOptions: Shopify.ProductOptions
        })
      })
      m.mount(productAddToCartButton, {
        view: () => m(PrescriptionToggleButton, {
          events,
          context: {
            addToCartText: Shopify.Button.PrescriptionButtonText,
            soldOutText: Shopify.Button.SoldOutText, 
            preorderText: Shopify.Button.PreorderText
          },
          state: states(),
          colour: 'green',
          moneyFormat: Shopify.currencyFormat,
          activeProductAvail: Shopify.Product.available,
          activeProductPreAvail: isAvailPreorder,
          activeProductId: Shopify.Product.id,
          activeProductPrice: Shopify.Product.price,
          activeProductSalePrice: Shopify.Product.compare_at_price
        })
      })

    }
  } else {
    if (productAddToCartButton) {
      m.mount(productAddToCartButton, {
        view: () => m(AddToCartButton, {
          events,
          context: {
            addToCartText: Shopify.Button.AddToCartText,
            soldOutText: Shopify.Button.SoldOutText, 
            preorderText: Shopify.Button.PreorderText
          },
          state: states(),
          colour: 'green',
          moneyFormat: Shopify.currencyFormat,
          activeProductAvail: Shopify.Product.available,
          activeProductPreAvail: isAvailPreorder,
          activeProductId: Shopify.Product.id,
          activeProductPrice: Shopify.Product.price,
          activeProductSalePrice: Shopify.Product.compare_at_price
        })
      })
    }
  }
}

function mountPageProductToCartButton () {
  let productAddToCartButtonHTMLCollection = document.querySelectorAll('.product_buttonContainer')
  
  if(productAddToCartButtonHTMLCollection.length > 0) {
    let productAddToCartButtons = Array.prototype.slice.call(productAddToCartButtonHTMLCollection)
    productAddToCartButtons.map(productAddToCartButton => {
      const productType = Shopify.Product.type
      const isAvailPreorder = Shopify.Product.preorderAvail
    
      if (productType.indexOf('Prescription') > -1) {
        let prescriptionSelector = document.getElementById('PrescriptionSelector')
        if (prescriptionSelector) {
          m.mount(prescriptionSelector, {
            view: () => m(PrescriptionSelector, {
              events,
              context: {
                addToCartText: Shopify.Button.PrescriptionButtonText,
                Prescription: Shopify.Prescription
              },
              state: states(),
              moneyFormat: Shopify.currencyFormat,
              product: Shopify.Product,
              productOptions: Shopify.ProductOptions
            })
          })
          m.mount(productAddToCartButton, {
            view: () => m(PrescriptionToggleButton, {
              events,
              context: {
                addToCartText: Shopify.Button.PrescriptionButtonText,
                soldOutText: Shopify.Button.SoldOutText, 
                preorderText: Shopify.Button.PreorderText
              },
              state: states(),
              colour: 'green',
              moneyFormat: Shopify.currencyFormat,
              activeProductAvail: Shopify.Product.available,
              activeProductPreAvail: isAvailPreorder,
              activeProductId: Shopify.Product.id,
              activeProductPrice: Shopify.Product.price,
              activeProductSalePrice: Shopify.Product.compare_at_price
            })
          })
    
        }
      } else {
        if (productAddToCartButton) {
          m.mount(productAddToCartButton, {
            view: () => m(AddToCartButton, {
              events,
              context: {
                addToCartText: Shopify.Button.AddToCartText,
                soldOutText: Shopify.Button.SoldOutText, 
                preorderText: Shopify.Button.PreorderText
              },
              state: states(),
              colour: 'green',
              moneyFormat: Shopify.currencyFormat,
              activeProductAvail: Shopify.Product.available,
              activeProductPreAvail: isAvailPreorder,
              activeProductId: Shopify.Product.id,
              activeProductPrice: Shopify.Product.price,
              activeProductSalePrice: Shopify.Product.compare_at_price
            })
          })
        }
      }
    })
  }
}

function mapProductWithButton() {
  const productAddToCartButtonHTMLCollection = document.querySelectorAll('.productSection_quickadd')
  if(productAddToCartButtonHTMLCollection) {
    let productAddToCartButtons = Array.prototype.slice.call(productAddToCartButtonHTMLCollection)
    productAddToCartButtons.map(productAddToCartButton => {
      Shopify.ProductMb = JSON.parse(productAddToCartButton.getAttribute('data-product'))
      Shopify.ProductMb.tags = productAddToCartButton.getAttribute('data-product-tags')
      Shopify.ProductMb.type = productAddToCartButton.getAttribute('data-product-type')
      Shopify.ProductMb.preorderAvail = productAddToCartButton.getAttribute('data-product-preorderAvail') > 0 ? true : false
      Shopify.ProductMbOptions = productAddToCartButton.getAttribute('data-product-options')
    
      const productType = Shopify.ProductMb.type
      const isAvailPreorder = Shopify.ProductMb.preorderAvail
    
      if (productType.indexOf('Prescription') > -1) {
        let prescriptionSelector = document.getElementById('PrescriptionSelector')
        if (prescriptionSelector) {
          m.mount(prescriptionSelector, {
            view: () => m(PrescriptionSelector, {
              events,
              context: {
                addToCartText: Shopify.Button.PrescriptionButtonText,
                Prescription: Shopify.Prescription
              },
              state: states(),
              moneyFormat: Shopify.currencyFormat,
              product: Shopify.ProductMb,
              productOptions: Shopify.ProductMbOptions
            })
          })
          m.mount(productAddToCartButton, {
            view: () => m(PrescriptionToggleButton, {
              events,
              context: {
                addToCartText: Shopify.Button.PrescriptionButtonText,
                soldOutText: Shopify.Button.SoldOutText, 
                preorderText: Shopify.Button.PreorderText
              },
              state: states(),
              colour: 'green',
              moneyFormat: Shopify.currencyFormat,
              activeProductAvail: Shopify.ProductMb.available,
              activeProductPreAvail: isAvailPreorder,
              activeProductId: Shopify.ProductMb.id,
              activeProductPrice: Shopify.ProductMb.price,
              activeProductSalePrice: Shopify.ProductMb.compare_at_price
            })
          })
    
        }
      } else {
        if (productAddToCartButton) {
          m.mount(productAddToCartButton, {
            view: () => m(AddToCartButton, {
              events,
              context: {
                addToCartText: Shopify.Button.AddToCartText,
                soldOutText: Shopify.Button.SoldOutText, 
                preorderText: Shopify.Button.PreorderText
              },
              state: states(),
              colour: 'green',
              moneyFormat: Shopify.currencyFormat,
              activeProductAvail: Shopify.ProductMb.available,
              activeProductPreAvail: isAvailPreorder,
              activeProductId: Shopify.ProductMb.id,
              activeProductPrice: Shopify.ProductMb.price,
              activeProductSalePrice: Shopify.ProductMb.compare_at_price
            })
          })
        }
      }
    })
  }
}

function mountBlockAddToCartButton() {
  const productBlocks = document.querySelectorAll('.productBlock, .productBlock-mobile')
  let soldOutText = Shopify.Button.SoldOutText

  
  if (productBlocks) {
    productBlocks.forEach((productBlock) => {
      const productJSON = productBlock.dataset.product
      const product = JSON.parse(productJSON)
      let activeProductAvail = product.available
      let activeProductPreAvail = productBlock.dataset.productPreorder === 'false' ? false : true
      const activeProductPrice = product.price
      const activeProductSalePrice = product.compare_at_price
      let activeProductId =product.id

      // change product id when variant changes for Mobiles
      let productVariantsMobile = Array.from(productBlock.querySelectorAll('.productVariant_colour'))
      productVariantsMobile.map(variant => {
        
        variant.addEventListener('change_variant', (event) => {
          let isAvailable = variant.getAttribute('data-availability')
          let isPreorder = variant.getAttribute('data-preorder') 
          const detailsContainer = variant.closest('.productBlock_details')
          const priceContainer = detailsContainer.querySelector('.product_price')
          const variantPrice = variant.getAttribute('data-price')
          let variantPriceSale = variant.getAttribute('data-price-sale') || null

          let priceHtml;

          if (isAvailable === 'false') {
            // change price to sold out
            priceHtml = soldOutText
            activeProductAvail = false

            if(isPreorder === 'false') {
              activeProductPreAvail = false
            } else {
              activeProductPreAvail = true 
            }
          } else {
            // change price to product price
            if(variantPriceSale) {
              priceHtml = '<span class="product_price-sale">' + variantPriceSale + '</span><span class="product_price-original">' + variantPrice + '</span>'

            } else {
              priceHtml = '<span>'  + variantPrice + '</span>'
            }
            activeProductAvail = true
          }

          priceContainer.innerHTML = priceHtml

          const variantId = parseInt(event.detail.variantId)
          activeProductId = variantId
          mountCoponenet()
        })
      })

      // change product id when variant changes for Desktops
      let variants = Array.from(productBlock.querySelectorAll('.product_colour'))
      variants.forEach(function(variant) {

        variant.addEventListener('mouseover', function(event) {
          event.preventDefault()
          let isAvailable = variant.getAttribute('data-availability')
          let isPreorder = variant.getAttribute('data-preorder') 

          if (isAvailable === 'false') {
            activeProductAvail = false

            if(isPreorder === 'false') {
              activeProductPreAvail = false
            } else {
              activeProductPreAvail = true 
            }
          } else {
            activeProductAvail = true
          }

          activeProductId = parseInt(variant.getAttribute('data-id'))
          mountCoponenet()
        })
      })

      const productBlockAddToCartButton = productBlock.querySelector('.productBlock_buttonContainer')

      function mountCoponenet() {
        m.mount(productBlockAddToCartButton, {
          view: () => m(AddToCartButton, {
            events,
            context: {
              addToCartText: Shopify.Button.AddToCartText,
              soldOutText: Shopify.Button.SoldOutText, 
              preorderText: Shopify.Button.PreorderText
            },
            state: states(),
            moneyFormat: Shopify.currencyFormat,
            activeProductAvail: activeProductAvail,
            activeProductPreAvail: activeProductPreAvail,
            activeProductId: activeProductId,
            activeProductPrice: activeProductPrice,
            activeProductSalePrice: activeProductSalePrice
          })
        })
      }

      mountCoponenet()
    })
  }
}
